<template>
    <div id="answerBox">
        <!-- CardSelection component is for choosing a card to Phase2 current placeholder.
            CardSelection shows cards from cardsToChooseFrom array which is saved in state
            object.
            SelectionType prop tells the placeholder where the card will be placed. -->
        <div>
            <CardSelection
                v-if="state.progress == 0"
                :title="state.propsTitle"
                :cardsToChooseFrom="state.cardsToChooseFrom"
                :selectionType="props.selectionType"
                :dontKnowCardsAreActive="state.dontKnowCardsAreActive"
                :backEnabled="true"
                @saveCardChoice="saveCardChoice"
                @goBack="goBack('CardSelection')" />
        </div>
            <!-- Answer component saves the answer why the card was chosen to the placeholder.
            Card and the title of Answer component is passed by props. -->
        <div class="vert-center">
            <OverlayAnswer
                v-if="state.progress == 1"
                :title="state.propsTitle"
                :card="state.answerToCard"
                @answer="saveAnswer"
                @goBack="goBack('Answer')" />
        </div>
    </div>
</template>

<script>

import {reactive} from "vue";
import Card from "./Card.vue";
import OverlayAnswer from "./OverlayAnswer.vue";
import CardTypeSelection from './CardTypeSelection.vue';
import CardSelection from './CardSelection.vue';

export default {
    name: "Overlay",
    components: {
        Card,
        OverlayAnswer,
        CardTypeSelection,
        CardSelection
    },
    props: {

        /**
         * CardType is used for the title texts passed to CardSelection and Answer component in 
         * template and to choose right types of cards to cardsToChooseFrom array.
         * selectionType tells where the card will be placed in Phase 2.
         */
        cardType: String,
        selectionType: String,
    },
    setup(props, {emit}) {

        /**
         * State object saves the progress index of the Overlay. The right component is
         * shown to the user based on the progress index.
         * cardsToChooseFrom is passed as a prop to CardSelection component when it's
         * time to choose a card for the placeholder.
         * dontKnowCardsAreActive is boolean value, passed to CardSelection component
         * and tells if a card can be chosen from cards placed to Don't know in Phase 1.
         * propsTitle is the title passed to either CardSelection or Answer component.
         * answerToCard is passed to Answer component. Means which card the
         * answer will be saved to.
         * history array saves the actions user has taken during the overlay so when goBack
         * is called, the right kind of information is deleted from right card based on the history. 
         */
        const state = reactive({
            progress: 0,
            cardsToChooseFrom: [],
            dontKnowCardsAreActive: false,
            propsTitle: null,
            answerToCard: null,
            history: [],
        });

        const saveCardsToChooseFrom = () => {
            const cardArray = JSON.parse(localStorage.getItem("cardArray"));

            // Set right type of cards to cardsToChooseFrom array
            state.cardsToChooseFrom = cardArray.filter(card => {
                if (card.phase1selection == props.cardType && !card.phase2selection)
                    return card;
            });

            state.dontKnowCardsAreActive = false;

            if (props.selectionType === 'Tavoite')
                state.dontKnowCardsAreActive = true;
            else if (props.selectionType === 'Ongelma')
                state.dontKnowCardsAreActive = true;
            else if (props.selectionType === 'Voimavara1')
                state.dontKnowCardsAreActive = true;
            else if (props.selectionType === 'Voimavara2')
                state.dontKnowCardsAreActive = true;

            state.propsTitle = 'Valitsit aihepiirin ' + props.cardType + '. Minkä kortin haluat käsitellä?';
        }

        const saveCardChoice = (card, selectionType) => {

            /**
             * Gets the cardArray from localStorage, finds the right card by id of the card in parameter.
             * Saves the phase2selection to the card and saves the array back to localStorage.
             */
            const cardArray = JSON.parse(localStorage.getItem("cardArray"));
            const cardToModifyIndex = cardArray.findIndex(cardInArray => cardInArray.id === card.id);

            cardArray[cardToModifyIndex].phase2selection = selectionType;
            localStorage.setItem("cardArray", JSON.stringify(cardArray));


            // Push object to history array. It's used when goBack is called to know what property from which card to delete
            const historyToSave = { modifiedCardId: cardArray[cardToModifyIndex].id, modifiedCardProperty: 'phase2selection' };
            state.history.push(historyToSave);

            state.answerToCard = card;

            if (state.answerToCard.phase1selection === "EnOsaaSanoa")
                state.propsTitle = 'Valitsit kortin ' + state.answerToCard.description + '.'
            else
                state.propsTitle = 'Valitsit aihepiirin ' + props.cardType + ' ja sieltä kortin ' + state.answerToCard.description + '.'

            state.progress++;
        }

        const saveAnswer = (card, answer) => {

            /**
             * Gets the cardArray from localStorage, finds the right card by id of the card in parameter.
             * Saves the answer to the card and saves the array back to localStorage.
             */
            const cardArray = JSON.parse(localStorage.getItem("cardArray"));
            const cardToModifyIndex = cardArray.findIndex(cardInArray => cardInArray.id === card.id);
            cardArray[cardToModifyIndex].answer = answer;
            localStorage.setItem("cardArray", JSON.stringify(cardArray));

            state.answerToCard = null;

            emit("deactivateOverlay");
        }

        const goBack = (from) => {
            // If going back from CardSelection, let Phase 2 component handle goBack
            if (from === "CardSelection")
                emit('goBack');
            else if (from === "Answer") {

                /**
                 * If going back from answer component, checks last item in history array,
                 * gets cardArray from localStorage, deletes the right property from right card,
                 * and saves cardArray back to localStorage
                 */
                const modifiedCardId = state.history[state.history.length-1].modifiedCardId;
                const cardArray = JSON.parse(localStorage.getItem("cardArray"));

                const cardToModifyIndex = cardArray.findIndex(cardInArray => cardInArray.id === modifiedCardId);

                if (state.history[state.history.length-1].modifiedCardProperty === "phase2selection")
                    delete cardArray[cardToModifyIndex].phase2selection;

                localStorage.setItem("cardArray", JSON.stringify(cardArray));

                state.answerToCard = null;
                state.propsTitle = 'Valitsit aihepiirin ' + props.cardType + '. Minkä kortin haluat käsitellä?';

                state.progress--;
            }
        }

        saveCardsToChooseFrom();
        return { state, saveAnswer, saveCardsToChooseFrom, saveCardChoice, props, goBack };

    },
    emits: ['deactivateOverlay', 'goBack'],
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h2 {
  margin-top: 10px;
  margin-bottom: 20px;
  font-size: 20px;
}

ul {
  list-style-type: none;
  padding: 0;
  width: 80%;
  margin: 0 auto;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: var(--link_color);
}

#answerBox {
    border-style: solid;
    border-width: 0px;
    border-color: rgb(100, 100, 100);
    position: absolute;
    background-color: rgba(120, 120, 120, 0.5);
    margin: auto;
    padding-top: 100px;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
}

.container {
    position: relative;
}

#answerBox::before {
    content: '';
    margin: auto;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    position: absolute;
    backdrop-filter: blur(3px);
    z-index: -1;
}

#textBox {
    border-style: solid;
    border-width: 1px;
    border-color: rgb(150, 150, 150);
    display: inline-block;
    resize: none;
}

button {
    background-color: rgb(255, 255, 170);
    border-style: none;
    font-size: 17px;
    width: 170px;
    height: 30px;
}

#backButton {
    display: inline-block;
    position: relative;
    left: -200px;
}

#answerButton {
    display: inline-block;
    position: relative;
    left: 200px;
}

::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
    font-size: 40px;
    color: rgb(180, 180, 180);
    text-align: center;
    transform: translate3d(0, 115px,0);
    opacity: 1; /* Firefox */
}

.vert-center {
    position: relative;
}
</style>
